import * as React from 'react';
import { createContext } from 'react';

import type { CampaignCannedCollectionModuleFragment } from 'bundles/campaigns/queries/__generated__/CannedCollectionModule';
import type { CampaignCardTakeoverModuleFragment } from 'bundles/campaigns/queries/__generated__/CardTakeoverModuleFragment';
import type { CampaignHeroModuleFragment } from 'bundles/campaigns/queries/__generated__/HeroModuleFragment';
import type { CampaignLearnerStatsModuleFragment } from 'bundles/campaigns/queries/__generated__/LearnerStatsModuleFragment';
import type { CampaignPromoBarModuleFragment } from 'bundles/campaigns/queries/__generated__/PromoBarModuleFragment';
import type { CampaignSpotlightCollectionsModuleFragment } from 'bundles/campaigns/queries/__generated__/SpotlightCollectionsModuleFragment';

type CampaignModulesDataContextType = {
  loading?: boolean;
  campaignData?: {
    heroModule?: CampaignHeroModuleFragment;
    collectionsModule?: CampaignSpotlightCollectionsModuleFragment;
    promoBarModule?: CampaignPromoBarModuleFragment;
    cannedCollectionModule?: CampaignCannedCollectionModuleFragment;
    cardTakeoverModule?: CampaignCardTakeoverModuleFragment;
    learnerStatsModule?: CampaignLearnerStatsModuleFragment;
  };
};

const CampaignModulesDataContext = createContext<CampaignModulesDataContextType>({});

export const useCampaignModulesData = () => {
  return React.useContext(CampaignModulesDataContext);
};

export default CampaignModulesDataContext;
